export default "__VITE_ASSET__54ec2896__"